import React from 'react';

import BaseComponent from '../../baseClasses/BaseComponent';
import VideoPlayer from '../VideoPlayer';
import animator from '../../helpers/animator';
import './ViewAttachmentPopup.scss';
import dataModel from '../../models/DataModel';
import AttachmentHelper from '../../helpers/AttachmentHelper';
import FileUtil from '../../helpers/FileUtil/FileUtil';

export default class ViewAttachmentPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { menu: null, openEditOptions: false, resourceAttachment: null };
    this.animated = false;
    this.animator = new animator();
    this.createResourceView = this.createResourceView.bind(this);
  }

  componentDidMount() {
    const { attachment } = this.props;
    if (attachment) {
      if (attachment.group_identifier) {
        dataModel.referenceDocumentsDAO.getReferenceDocument(attachment.id, { force: true, recordDescriptor: { reference_document: { conversions: { } } } }).then((refDoc) => {
          this.setState({ resourceAttachment: refDoc });
        });
      }
      else {
        dataModel.uniqueDocumentsDAO.getUniqueDocument(attachment.id,
          { force: true, recordDescriptor: { unique_document: { conversions: { } } } }).then((uniqueDocument) => {
            this.setState({ resourceAttachment: uniqueDocument });
          });
      }
    }
  }

  animateMe() {
    this.animated = true;
    const _this = this;
    setTimeout(() => {
      const ani = _this.animator.createPropertyAnimation('view-attachment-popup' + this.props.attachment.id, 300, {
        opacity: { startVal: 0, endVal: 1 },
      });
      _this.animator.addAnimation(ani);
      _this.animator.processAnimationQueue();
    }, 10);
  }

  handleClose() {
    const ani = this.animator.createPropertyAnimation('view-attachment-popup' + this.props.attachment.id, 300, {
      opacity: { startVal: 1, endVal: 0 },
    });

    this.animator.addAnimation(ani);
    const _this = this;
    this.animator.processAnimationQueue(() => {
      const { handlePopupClose } = _this.props;
      if (handlePopupClose) {
        handlePopupClose();
      }
    });
  }

  handleKeyDown(e) {
    if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClose();
    }
  }

  createImageView(attachment) {
    const { imageHeight, imageWidth } = this.props;

    let imageView = <img style={{ maxHeight: imageHeight ? imageHeight : 581, maxWidth: imageWidth ? imageWidth : 710 }}
      src={attachment.upload ? attachment.upload : attachment.attachment} alt='attachment' />;
    return imageView;
  }

  createVideoView(attachment){
    const type = attachment && attachment.upload_content_type ? attachment.upload_content_type : (attachment && attachment.upload && attachment.upload.type) ? attachment.upload.type : undefined;
    let videoView = <VideoPlayer src={attachment.upload ? attachment.upload : attachment.attachment} type={type}/>;
    return videoView;
  }

  createResourceView(attachment){
    let type = FileUtil.getExtension(attachment.name);
    let view = null;
    switch(type.toLowerCase()){
    case 'png':
    case 'jpg':
    case 'jpeg':
      view = 
          <div className='task-resource'>
            {this.createImageView(attachment)}
          </div>;
      break;
    case 'mp4':
    case 'mp4v':
    case 'mov':
    case 'wmv':
    case 'flv':
    case 'qt':
    case 'm4v':
      view = 
          <div className='task-resource'>
            {this.createVideoView(attachment)}
          </div>;
      break;
    case 'pdf':
    case 'doc':
    case 'docx':
    case 'xls':
    case 'xlt':
    case 'xlm':
    case 'xlsm':
    case 'xlsx':
    case 'xltx':
      view = 
        <div className='display-container'>
          {AttachmentHelper.getConvertedDocumentView(attachment)}
        </div>;

      break;
    default:
      view = 
        <div className='task-resource'>
          {this.createImageView(attachment)}
          </div>;
      break;
    }
    return view;
  }
  
  render() {
    let { left, top, width, height, attachment, popupGlobal } = this.props;

    let actualTop = top;
    let actualLeft = left;
    let actualHeight = height ? height : 643;
    let actualWidth = width ? width : 763;

    if (!this.state.resourceAttachment) {
      return null;
    }

    if (!this.animated) {
      this.animateMe();
    }

    const resource = this.createResourceView(this.state.resourceAttachment);

    if (popupGlobal) {
    }
    else {
      if (actualTop + actualHeight >= window.innerHeight) {
        actualTop = window.innerHeight - actualHeight - 30;
      }
      if (actualLeft + actualWidth >= window.innerWidth) {
        actualLeft = window.innerWidth - actualWidth - 30;
      }
    }
    const style = { top: actualTop, left: actualLeft, width: width ? width : 800, height: height ? height : 620 };  
      
    return (
      <div id={'view-attachment-popup' + (attachment.id ? attachment.id : Math.floor(Math.random() * 20000))} className={'view-attachment-popup' + (popupGlobal ? ' popup-global' : '')} style={style}
        onKeyDown={this.handleKeyDown}>
        <div className='task-content'>
          <div className='task-caption'>
            <div className='task-title'>{attachment.name}</div>
          </div>
          {resource}
        </div>
        <div className="close-button" onClick={this.handleClose}></div>
      </div>
    );
  }
}

// Change to appropriate class name




// WEBPACK FOOTER //
// ./src/components/ViewAttachmentPopup/index.js